import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    "apiKey": "AIzaSyAwQVuihouqGgPOcB_bCv392A495P-LVIo",
    "appId": "1:218973661940:web:2c2d3703c835d107f94ca1",
    "authDomain": "smp-scrappy-dev.firebaseapp.com",
    "databaseURL": "projects/smp-scrappy-dev/databases/(default)",
    "projectId": "smp-scrappy-dev",
    "measurementId": "",
    "messagingSenderId": "218973661940",
    "storageBucket": "smp-scrappy-dev.appspot.com"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);
const analytics = getAnalytics(app);

// export singleton instances
export { analytics, app, auth, firestore };

